export default "__VITE_ASSET__BkOzTFQE__"